import { Button } from "primereact/button";
import { OverlayPanel } from "primereact/overlaypanel";
import { useRef } from "react";
import UpdateEmailButton from "./UpdateEmailButton";
import UpdatePasswordButton from "./UpdatePasswordButton";

const SettingsButton: React.FC = () => {
  const opRef = useRef<OverlayPanel>(null);

  return (
    <>
      <Button
        icon="pi pi-sliders-h"
        className="p-button-outlined"
        onClick={(e) => opRef.current && opRef.current.toggle(e)}
      ></Button>
      <OverlayPanel ref={opRef} dismissable showCloseIcon>
        {/* <UpdateEmailButton /> */}
        <UpdatePasswordButton />
      </OverlayPanel>
    </>
  );
};

export default SettingsButton;
